import { curYearNum, getWeekDaysByWeekNumber, weekCount } from "./date";

export const getFrequency = (str = "") => {
  const key = String(str).toLowerCase();
  return key === "weekly"
    ? 52.1429
    : key === "fortnightly"
    ? 26.0714
    : key === "monthly"
    ? 12
    : key === "quarterly"
    ? 4
    : key === "half yearly"
    ? 2
    : 1;
};

export const innerHeight = (height = 0, minusValue = 200) => {
  if (height) {
    return height;
  }
  return Math.max(500, window.innerHeight - minusValue);
};

export const openNewTab = (url = "") => {
  var link = document.createElement("a");
  // Add the element to the DOM
  document.body.appendChild(link);
  link.setAttribute("type", "hidden"); // make it hidden if needed
  link.setAttribute("target", "_blank"); // make it hidden if needed
  link.href = url;
  link.click();
  link.remove();
};

export const weeklyInfos = Array.from(Array(weekCount).keys()).reduce(
  (ret, cur, index) => {
    const label = `Week ${cur + 1} (${getWeekDaysByWeekNumber(
      cur + 1,
      0,
      "DD MMM",
      curYearNum
    )} ~ ${getWeekDaysByWeekNumber(cur + 1, 6, "DD MMM", curYearNum)})`;
    return [...ret, { id: cur + 1, label: label }];
  },
  []
);
